(() => {
  const heroSelector = '[data-faq-page-hero]'
  const sectionSelector = '[data-faq-section]'
  const itemSelector = '[data-faq-item]'

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches
  }

  function setItemOpen(item, open) {
    const trigger = item?.querySelector('[data-faq-trigger]')
    const answer = item?.querySelector('[data-faq-answer]')
    if (!trigger || !answer) return

    trigger.setAttribute('aria-expanded', String(open))
    answer.hidden = !open
  }

  function initAccordionItem(item) {
    if (!item || item.dataset.faqInitialized === 'true') return
    item.dataset.faqInitialized = 'true'

    const trigger = item.querySelector('[data-faq-trigger]')
    if (!trigger) return

    trigger.addEventListener('click', () => {
      const open = trigger.getAttribute('aria-expanded') !== 'true'
      setItemOpen(item, open)

      if (open && item.id) {
        const url = new URL(window.location.href)
        url.searchParams.set('faq', item.id)
        window.history.replaceState(null, '', url)
      }
    })
  }

  function getFaqSearchText(item) {
    return [
      item.dataset.faqQuestion,
      item.dataset.faqTopic,
      item.dataset.faqKeywords,
      item.textContent
    ]
      .filter(Boolean)
      .join(' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase()
  }

  function getCategorySectionFromHash() {
    const rawHash = window.location.hash.slice(1)
    if (!rawHash) return null

    let categoryId = rawHash
    try {
      categoryId = decodeURIComponent(rawHash)
    } catch (error) {
      categoryId = rawHash
    }

    const section = document.getElementById(categoryId)
    return section?.matches(sectionSelector) ? section : null
  }

  function scrollToCategoryFromUrl(behavior = 'auto') {
    const section = getCategorySectionFromHash()
    if (!section) return

    section.scrollIntoView({
      behavior: prefersReducedMotion() ? 'auto' : behavior,
      block: 'start'
    })
  }

  function initHero(hero) {
    if (!hero || hero.dataset.faqHeroInitialized === 'true') return
    hero.dataset.faqHeroInitialized = 'true'

    const search = hero.querySelector('[data-faq-search]')
    const clear = hero.querySelector('[data-faq-search-clear]')
    const nav = hero.querySelector('[data-faq-category-nav]')
    const noResults = hero.querySelector('[data-faq-no-results]')
    const queryOutput = hero.querySelector('[data-faq-search-query]')
    const categoryLinks = Array.from(hero.querySelectorAll('[data-faq-category-link]'))

    function allSections() {
      return Array.from(document.querySelectorAll(sectionSelector))
    }

    function allItems() {
      return Array.from(document.querySelectorAll(itemSelector))
    }

    function filterFaqs() {
      const rawQuery = search?.value.trim() || ''
      const query = rawQuery.toLowerCase()
      const queryTerms = query.split(/\s+/).filter(Boolean)
      let visibleCount = 0

      if (clear) clear.hidden = !query
      if (nav) nav.hidden = Boolean(query)

      allItems().forEach((item) => {
        if (!item.dataset.faqSearchText) {
          item.dataset.faqSearchText = getFaqSearchText(item)
        }

        const matches = !queryTerms.length
          || queryTerms.every((term) => item.dataset.faqSearchText.includes(term))
        item.hidden = !matches
        if (matches) visibleCount += 1
      })

      allSections().forEach((section) => {
        const hasVisibleItems = Array.from(section.querySelectorAll(itemSelector))
          .some((item) => !item.hidden)
        section.hidden = !hasVisibleItems
      })

      if (noResults) noResults.hidden = visibleCount !== 0
      if (queryOutput) queryOutput.textContent = rawQuery
    }

    search?.addEventListener('input', filterFaqs)
    clear?.addEventListener('click', () => {
      if (!search) return
      search.value = ''
      filterFaqs()
      search.focus()
    })

    categoryLinks.forEach((link) => {
      link.classList.remove('is-active')
      link.removeAttribute('aria-current')

      link.addEventListener('click', (event) => {
        const targetHash = link.getAttribute('href')
        const targetId = targetHash?.startsWith('#') ? targetHash.slice(1) : ''
        const target = targetId ? document.getElementById(targetId) : null
        if (!target) return

        event.preventDefault()

        if (window.location.hash !== targetHash) {
          const url = new URL(window.location.href)
          url.hash = targetHash
          window.history.pushState(null, '', `${url.pathname}${url.search}${url.hash}`)
        }

        target.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' })
      })
    })

    filterFaqs()
  }

  function openFaqFromUrl() {
    const faqId = new URLSearchParams(window.location.search).get('faq')
    if (!faqId) return
    const item = document.getElementById(faqId)
    if (!item?.matches(itemSelector)) return

    setItemOpen(item, true)
    requestAnimationFrame(() => {
      item.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'center' })
    })
  }

  function initWithin(scope = document) {
    if (scope.matches?.(itemSelector)) initAccordionItem(scope)
    scope.querySelectorAll?.(itemSelector).forEach(initAccordionItem)
    if (scope.matches?.(heroSelector)) initHero(scope)
    scope.querySelectorAll?.(heroSelector).forEach(initHero)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initWithin()
      openFaqFromUrl()
      requestAnimationFrame(() => scrollToCategoryFromUrl())
    }, { once: true })
  } else {
    initWithin()
    openFaqFromUrl()
    requestAnimationFrame(() => scrollToCategoryFromUrl())
  }

  window.addEventListener('popstate', () => scrollToCategoryFromUrl())
  window.addEventListener('hashchange', () => scrollToCategoryFromUrl())
  document.addEventListener('shopify:section:load', (event) => initWithin(event.target))
})()
